import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './routes';

import { registerSW } from 'virtual:pwa-register';
import { useAuthStore } from '@/modules/auth/stores/authStore';

import 'bootstrap'; // Hier importieren wir das Bootstrap JavaScript

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowDownLong,
  faArrowRightFromBracket,
  faArrowRightToBracket,
  faArrowUpLong,
  faBars,
  faCertificate,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircleCheck,
  faCircleInfo,
  faClipboard,
  faEnvelope,
  faFile,
  faFileContract,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileMedical,
  faFileSignature,
  faFloppyDisk,
  faFolder,
  faGear,
  faHashtag,
  faHouse,
  faLink,
  faMagnifyingGlass,
  faMagnifyingGlassPlus,
  faPause,
  faPen,
  faPenToSquare,
  faPlay,
  faPlug,
  faPlugCircleXmark,
  faPlus,
  faPrint,
  faRotate,
  faServer,
  faTableColumns,
  faTableList,
  faTag,
  faTrash,
  faUsers,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faArrowRightToBracket,
  faArrowRightFromBracket,
  faArrowUpLong,
  faArrowDownLong,

  faBars,

  faCertificate,
  faCheck,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faCircleCheck,
  faCircleInfo,
  faClipboard,

  faEnvelope,

  faFile,
  faFileContract,
  faFileMedical,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileSignature,
  faFloppyDisk,
  faFolder,

  faGear,

  faHashtag,
  faHouse,

  faLink,

  faMagnifyingGlass,
  faMagnifyingGlassPlus,

  faPause,
  faPen,
  faPenToSquare,
  faPlay,
  faPlug,
  faPlugCircleXmark,
  faPlus,
  faPrint,

  faRotate,

  faServer,

  faTableColumns,
  faTableList,
  faTag,
  faTrash,

  faUsers,

  faXmark
);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

registerSW({ immediate: true });

async function bootstrap() {
  const app = createApp(App);
  app.use(createPinia());

  // app.use(store); // Vuex Store einbinden, solange Vuex noch verwendet wird

  app.use(router);
  app.component('font-awesome-icon', FontAwesomeIcon);

  const auth = useAuthStore();
  await auth.initAuth();

  if (!auth.isAuthenticated) {
    auth.login();
  }

  app.mount('#app');
}

bootstrap();
